import Switch from 'react-bootstrap-switch';
import { SWITCH_BS_SIZES, SWITCH_COLORS } from './SwitchConstants';
Switch.SWITCH_BS_SIZES = SWITCH_BS_SIZES;
Switch.SWITCH_COLORS = SWITCH_COLORS;
export default Switch;